import React, { useState } from 'react';
import { useTheme } from '@material-ui/core';
import { sortBy } from 'lodash/fp';
import {
    WarehouseCardFormQueryComponent,
} from '../../../../generated/graphql';
import { FullScreenDialog } from '../../../../ui-kit';
import WarehouseCardFormView from './WarehouseCardFormView';
import { WarehouseCardFormValues } from './types';

interface WarehouseCardFormProps {
    onSubmit: (formValues: WarehouseCardFormValues) => Promise<void>;
    buttonText: string;
    dialogName: string;
    currentWarehouseId: string;
    requiredWarehouseIds?: string[];
    initialValues?: Partial<WarehouseCardFormValues>;
    isUpdate?: boolean;
    onClose?(): void;
    onRemove?(): void;
    onlyPieces?: boolean;
}

const WarehouseCardForm = ({
    onSubmit,
    buttonText,
    dialogName,
    currentWarehouseId,
    requiredWarehouseIds,
    initialValues,
    isUpdate,
    onlyPieces,
    onClose,
    onRemove,
}: WarehouseCardFormProps) => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const theme = useTheme();

    const handleClose = () => {
        setIsDialogOpened(false);
        if (onClose) {
            setTimeout(onClose, theme.transitions.duration.leavingScreen);
        }
    };

    const handleSubmit = async (formVariables: WarehouseCardFormValues) => {
        await onSubmit(formVariables);
        handleClose();
    };

    const content = (
        <WarehouseCardFormQueryComponent partialRefetch>
            {({ data: { taxes, stockCardCategories, warehouses } }) => {
        const sortedTaxes = sortBy(['rate', 'asc'], taxes);
        const sortedWarehosueCategories = sortBy([({ name }) => name.toLowerCase(), 'asc'], stockCardCategories);
        const sortedWarehouses = sortBy([({ name }) => name.toLowerCase(), 'asc'], warehouses);
        const currentTaxId = taxes[0].id;

        return (
            <WarehouseCardFormView
                requiredWarehouseIds={requiredWarehouseIds}
                onlyPieces={onlyPieces}
                isUpdate={isUpdate}
                initialValues={initialValues}
                categories={sortedWarehosueCategories}
                taxes={sortedTaxes}
                buttonText={buttonText}
                dialogName={dialogName}
                onClose={handleClose}
                currentTaxId={currentTaxId}
                currentWarehouseId={currentWarehouseId}
                onSubmit={handleSubmit}
                warehouses={sortedWarehouses}
                onRemove={onRemove}
            />
        );
    }}
        </WarehouseCardFormQueryComponent>
    );

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            {content}
        </FullScreenDialog>
    );

};

export default WarehouseCardForm;
